import templateUrl from "emun.auth/users/user-fieldset.htm";
import controller from "emun.auth/users/user-fieldset.controller";

export default {
  bindings: {
    request: "<user",
    bus: "<?",
    hideLabel: "@",
    hideTags: "@",
    hideRole: "<?",
    hideCompanyName: "@",
    hideRating: "@",
    overrideLabels: "<?",
    type: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
